import axios from "../axios";
import h from "../helpers";

/**
 * storeReport — laporan toko berbasis transaksi POS (ERP side, `authUser`).
 * Beda domain dari `report.js` lama (yang berbasis `sales_order`), mount
 * terpisah di prefix `store-report`. `warehouse_id` opsional di semua
 * endpoint (kosongkan untuk melihat seluruh outlet), `start_date`/`end_date`
 * ISO date string, inklusif.
 */
const storeReport = {
  transactions: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/transactions"), {
      params: { ...params },
    });
    // Backend hanya mengirim { total, page, limit } — `totalPages` dihitung
    // di sini supaya bisa langsung dipakai oleh ServerSidePaginationButtons
    // (komponen bersama itu mengharap `paginationProps.totalPages`).
    if (data?.pagination) {
      const { total, limit } = data.pagination;
      data.pagination = {
        ...data.pagination,
        totalPages: limit ? Math.ceil((+total || 0) / limit) : 0,
      };
    }
    return data;
  },
  salesTotals: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/sales-totals"), {
      params: { ...params },
    });
    return data;
  },
  membership: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/membership"), {
      params: { ...params },
    });
    return data;
  },
  outletStock: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/outlet-stock"), {
      params: { ...params },
    });
    return data;
  },
  stockMutation: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/stock-mutation"), {
      params: { ...params },
    });
    return data;
  },
  warehouseInOut: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/warehouse-in-out"), {
      params: { ...params },
    });
    return data;
  },
  salesByProduct: async (params) => {
    const { data } = await axios.get(
      h.baseUrl("store-report/sales-by-product"),
      { params: { ...params } }
    );
    return data;
  },
  salesByCategory: async (params) => {
    const { data } = await axios.get(
      h.baseUrl("store-report/sales-by-category"),
      { params: { ...params } }
    );
    return data;
  },
  salesByCashier: async (params) => {
    const { data } = await axios.get(
      h.baseUrl("store-report/sales-by-cashier"),
      { params: { ...params } }
    );
    return data;
  },
  salesByPaymentMethod: async (params) => {
    const { data } = await axios.get(
      h.baseUrl("store-report/sales-by-payment-method"),
      { params: { ...params } }
    );
    return data;
  },
  dailyClosing: async (params) => {
    const { data } = await axios.get(h.baseUrl("store-report/daily-closing"), {
      params: { ...params },
    });
    return data;
  },
};

export default storeReport;
